module.exports = __webpack_public_path__ + "h5/img/child-banner-bot.f52b740b.png";